export class OneOfFeeSpacePeriodPackagePriceRoom {
  id: number | undefined
  active: boolean
  hours: number
  free: boolean
  discount: object | null
  totalPrice: object | null
  deskPrice: object | null
  dateCreated: Date | string
  oneOfFee: object | null
  roomTypePeriodPackagePrice: object | null

  constructor() {
    this.active = false
    this.hours = 0
    this.free = false
    this.discount = 0
    this.totalPrice = null
    this.deskPrice = null
    this.dateCreated = ''
    this.oneOfFee = null
    this.roomTypePeriodPackagePrice = null
  }
}
